<ssab-order-confirmation-header
  [order$]="order$"
></ssab-order-confirmation-header>
